// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UNpD","right":"styles_right__261mB"};